import { useMemo } from 'react';

import { useCountries } from '@/hooks';

export type LocationProps = {
  location: {
    country: string;
    city: string[];
  }[];
};

export function useLocation({ location }: LocationProps): string | null {
  const { kv } = useCountries();
  return useMemo(() => {
    if (!location || !location.length) return null;

    return location
      .map(({ country, city }) => {
        const countryLabel = kv[country];
        const cityLabel = city.filter(Boolean).join(', ');
        return cityLabel ? `${countryLabel} (${cityLabel})` : countryLabel;
      })
      .join(', ');
  }, [kv, location]);
}
